import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { APIRithmic } from "../../../../api";
import { ICustomerE2TAccount } from "../../../../api/rithmic/index.types";
import { ContainerWithLoader, E2TAccountIDsList } from "../../../../components/ui";
import { RITHMIC_API_URLS } from "../../../../api/rithmic";

interface IProps {
  email: string;
}
const E2TAccountsList: React.FC<IProps> = ({ email }) => {
  const [e2tAccounts, setE2tAccounts] = useState("");
  const [responseData, setResponseData] = useState<ICustomerE2TAccount[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useQuery({
    enabled: !!email,
    queryKey: [RITHMIC_API_URLS.rithmic_accounts, email],
    queryFn: async () => {
      setIsLoading(true);
      const {
        data: { e2tAccounts },
      } = await APIRithmic.getRithmicAccountsByCustomer(email);
      setResponseData(e2tAccounts);
      let accounts = "";
      e2tAccounts.forEach(({ account }, index) => {
        accounts += `${account}${e2tAccounts.length - 1 === index ? "" : ", "}`;
      });
      setE2tAccounts(accounts.toString());
      setIsLoading(false);
    },
  });

  return (
    <div>
      <b>E2T Accounts</b>
      <ContainerWithLoader
        report={responseData}
        isLoading={isLoading}
        noResultsMessage="There are not e2t accounts"
      >
        <E2TAccountIDsList accounts={e2tAccounts} />
      </ContainerWithLoader>
    </div>
  );
};

export default E2TAccountsList;
